export const NATIVE_SOLANA_MINT_ADDRESS = 'So11111111111111111111111111111111111111111';
